import { createStore } from 'vuex'

export default createStore({
  state: {
    // API: '/api',
    // API: 'http://127.0.0.1:5003',
    // API: '/api',
    // API: '/api',
    API: 'https://megaache.collaborationspharma.com/api',
    // models: [],
    selectedModels: [],
    smiles: ''
  },
  getters: {
    API: state => state.API,
    models: state => state.models,
    selectedModels: state => state.selectedModels,
    smiles: state => state.smiles
  },
  mutations: {
    models: (state, models) => {
      state.models = models
    },
    selectedModels (state, model) {
      state.selectedModels = model
    },
    smiles (state, smiles) {
      state.smiles = smiles
    }
  },
  actions: {
  },
  modules: {
  }
})
